import KycFormPending from "../components/KycFormPending";

const KycVerificationPending = () => (
  <div className="relative z-10 w-full max-w-md px-6 py-8">
    <div className="mb-8 flex justify-center">
      <img
        src="/kyc-verify.png"
        alt="kyc pending"
        className="h-[129px] w-[121px]"
      />
    </div>
    <KycFormPending />
  </div>
);

export default KycVerificationPending;
